export default __webpack_public_path__ + "static/media/image8.126c3064.png";